<template>
  <article class="product-item relative flex c-flex-col c-flex-grow-1 overflow-hidden">
    <ProductItemToast
      class="c-pt-3 c-px-3"
      :toast-operation="toastObject"
    />
    <div class="c-px-4 c-sm:c-px-3 c-md:c-px-4 c-pt-4 c-sm:c-pt-3 c-md:c-pt-4">
      <div class="catalog__grid-img c-mb-4">
        <RemoteResponsiveImage
          :placeholder="true"
          placeholder-height="75"
          :product-image-data="product.images[0]?.data"
          img-class="w-100 h-100"
          :lazy-load="lazyLoad"
          width="600"
          height="450"
          :alt="product.images[0].alt || product.name"
          sizes="(min-width: 1200px) 25vw, (min-width: 992px) 20vw, (min-width: 600px) 35vw, (min-width: 500px) 50vw, 70vw"
        />
      </div>
    </div>
    <DiscountBubble
      v-if="product.hasDiscount || (parseFloat(product.plusClubPrice) > 0 && getCurrentCustomer?.inPlusClub)"
      :price-with-discount="parseFloat((parseFloat(product.plusClubPrice) > 0) && getCurrentCustomer?.inPlusClub ? product.plusClubPrice : product.price)"
      :price-without-discount="parseFloat(product.priceWithoutDiscount)"
      :currency="product.currency"
    />
    <div
      v-if="(product.name.includes('Premium') || product.name.includes('Prémium')) && !product.name.includes('Birch')"
      class="stamp-holder c-mx-4 c-sm:c-mx-3 c-md:c-mx-4"
    >
      <div

        class="special-stamp stamp-grid c-pr-3 c-py-1 c-rounded-pill"
      >
        <div class="stamp-box">
          <StampIconSvg
            class="icon stamp-icon"
            width="62"
            height="62"
          />
          <div class="flag-mask">
            <StampItalyFlagSvg
              class="icon"
              width="25"
              height="23"
            />
          </div>
        </div>
        <span class="c-m-0 font-bold inline-block">{{ t('own_piece_of_italy') }}</span>
      </div>
    </div>
    <div class="c-px-4 c-sm:c-px-3 c-md:c-px-4 flex c-flex-col c-flex-fill">
      <div class="flex c-mb-2 c-items-center">
        <div
          v-if="!product.starRating || (product.starRating && parseInt(product.starRating) === 0)"
          class="c-mb-2 c-md:flex hidden"
          style="height: 24px;"
        />
        <ProductStarsRating
          v-else
          :rating="product.starRating"
          :rating-sum="product.starRatingCommentsSum"
          :show-origin="true"
          add-class="c-xxl:c-justify-start"
          theme="light"
        />
        <template v-if="product.commentsSum">
          <hr
            v-if="product.starRating && parseInt(product.starRating) > 0"
            class="rating-divider bg-primary c-mx-2 c-my-0"
          >
          <span>
            <i class="mi-comment" /> {{ product.commentsSum }}
          </span>
        </template>
      </div>
      <h2 class="c-mb-2 text-lg-c font-medium font-family-base">
        <router-link
          :to="productPath"
          class="text-primary !no-underline stretched-link z-1"
        >
          {{ product.name }}
        </router-link>
      </h2>
      <!-- short product description (with no html tags, and 170 length max) -->
      <div
        v-if="product.positives"
        class="product-item__description text-sm-c text-muted show mb-n1"
        v-html="product.positives"
      />
      <div
        v-else
        class="product-item__description text-sm-c text-muted show mb-n1"
      >
        <span
          v-if="product.state === 'weather_too_hot'"
          class="text-info"
        >{{ t('selected_chocolate_products') }}&nbsp;</span>
        <span v-html="product.shortDescription || shortDescription" />
      </div>
      <div v-if="false" class="c-xl:c-mt-4 c-mt-3 flex c-flex-row c-items-center">
        <div
          v-for="property in marketingProperties"
          :key="property.id"
          v-tooltip="{ content: property.name, theme: 'baseTooltip' }"
          class="col-auto c-pl-0 c-pr-0 c-mr-2 c-mt-1 relative z-2"
        >
          <i :class="`mi-${propertyIcon(property.systemName)} icon-property mi-no-mx mi-lh-1`" />
        </div>
        <div
          v-if="product.isIngredient"
          class="col-auto c-mt-1 c-ml-auto hidden c-md:block"
        >
          <button
            id="btn-close"
            type="button"
            class="btn btn-outline-warning c-p-1 c-rounded-circle relative z-2"
            data-toggle="product-detail-modal"
            aria-label="product info"
            @click="infoBtnClicked"
          >
            <i class="mi-info" />
          </button>
        </div>
      </div>
      <footer
        class="form-row c-mt-auto"
        :class="product.plusClubPrice && parseInt(product.plusClubPrice) !== 0 ? 'mb-1' : 'mb-5'"
      >
        <div
          v-if="product.expectedDeliveryDate || product.carrierHandoverDate || product.immediateDelivery"
          class="col-12 c-px-0 c-pt-3"
        >
          <ProductEstimatedTransport
            :expected-delivery-date="product.expectedDeliveryDate"
            :carrier-handover-date="product.carrierHandoverDate"
            :immediate-delivery="product.immediateDelivery"
            :porduct-index="true"
          />
        </div>
        <div
          class="col-6 flex c-flex-col c-justify-center c-pt-2"
        >
          <p class="c-mb-0 flex text-lg-c">
            <strong class="whitespace-nowrap c-mr-2 c-sm:c-mr-1 c-md:c-mr-2 c-xl:c-mr-3 c-xxl:c-mr-4 !font-extrabold">
              <span
                v-if="product.quantityDiscounts"
                :class="{
                  'line-through text-danger': parseFloat(product.plusClubPrice) > 0 && getCurrentCustomer?.inPlusClub,
                }"
              >
                <ProductPrice
                  :price-first="product.quantityDiscounts[0].price"
                  :price-second="product.quantityDiscounts.at(-1)?.price"
                  :plus-club-price="product.plusClubPrice"
                  :in-plus-club="getCurrentCustomer?.inPlusClub"
                  :currency="product.currency"
                  :show-from-text="t('from')"
                />
              </span>
              <span v-else>
                <ProductPrice
                  :price-first="product.price"
                  :currency="product.currency"
                />
              </span>
              <span
                v-if="(product.weight > 0 || product.volume > 0) && (!product.quantityDiscounts || !product.hasDiscount)"
                class="small whitespace-nowrap text-muted"
              > /{{ product.unit === 'g' ? product.weight : product.volume }} {{ product.unit }}</span>
            </strong>
          </p>
          <p
            v-if="product.hasDiscount && (parseFloat(product.plusClubPrice) > 0 || !getCurrentCustomer?.inPlusClub)"
            class="c-mb-0 flex text-lg-c"
          >
            <strong class="line-through text-danger text-sm-c whitespace-nowrap c-mr-2 c-sm:c-mr-1 c-md:c-mr-2 c-xl:c-mr-3 c-xxl:c-mr-4">
              <ProductPrice
                :price-first="product.priceWithoutDiscount"
                :currency="product.currency"
              />
            </strong>
          </p>
          <p
            v-if="product.pricePerPortion && product.pricePerPortion !== 'Infinity'"
            class="small c-mb-0 text-muted"
          >
            ({{ parseFloat(product.pricePerPortion).toFixed(2) }} {{ product.currency }} / 100 {{ product.unit }})
          </p>
        </div>
        <div
          v-if="status !== 'cementery'"
          class="col-6 flex c-flex-col c-px-0 c-justify-center c-pt-2 z-2"
          :class="{ 'mt-auto': product.hasDiscount }"
        >
          <AddToCartButton
            v-if="!product.isIngredient && product.state === 'available'"
            v-close-popper
            :product="product"
            :show-decrement-button="true"
            :gtm-source="isSearchPage ? 'search-results' : undefined"
            @cart-operation="(operation) => { toastObject = operation; }"
          />
          <PushToMixButton
            v-else-if="product.isIngredient && product.state === 'available'"
            :product="product"
          />
          <ButtonState
            v-else
            :product="product"
            :state="product.state"
          />
        </div>
        <div
          v-if="status === 'cementery'"
          class="col-12 c-sm:col-6 flex c-flex-col c-px-0 c-pt-2"
        >
          <ButtonState
            :product="product"
            added-class="z-1 relative c-mb-2"
            state="revive_me"
            :stretched="false"
          />
          <ButtonState
            :product="product"
            added-class="z-1 relative"
            state="mix_me"
            :stretched="false"
          />
        </div>
      </footer>
    </div>
    <div
      v-if="product.plusClubPrice && parseFloat(product.plusClubPrice) > 0"
      class="flex c-items-center c-pt-2 c-px-4 c-sm:c-px-3 c-md:c-px-4 c-flex-wrap bg-primary-450"
    >
      <p class="c-mb-0 flex text-lg-c c-mb-1">
        <strong class="whitespace-nowrap c-mr-1">
          <ProductPrice
            :price-first="product.plusClubPrice"
            :currency="product.currency"
          />
        </strong>
      </p>
      <router-link
        :to="{ name: 'productPath', params: { permalink: t('voucher_permalink') } }"
        class="flex c-justify-start c-items-center c-mb-1 !no-underline relative z-2"
      >
        <MixitPlusLogoSvg
          width="106"
          class="c-mr-1 relative c-mt-1"
          plus-color="#ffffff"
        />
        <span class="whitespace-nowrap">{{ t('mixit_plus_price') }}</span>
        <span class="flex border border-primary border-2 text-primary c-p-0 c-rounded-circle c-ml-2">
          <i class="mi-question icon-12" />
        </span>
      </router-link>
    </div>
    <!-- video play -->
    <ButtonPlayVideo
      v-if="product.videoUrl"
      class="absolute left-0 top-0 c-m-2 c-md:c-m-3 c-lg:c-m-4"
      :video-url="product.videoUrl"
    />
    <!-- add to favourite -->
    <Favorite
      v-if="!product.isIngredient"
      :id="product.id"
      btn-class="icon bg-white"
      class="absolute top-0 right-0 fav-right z-2"
    />
  </article>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { striptags } from 'striptags'
import { computed, defineAsyncComponent, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import ApiServiceV1 from '@/api/adminApi/AdminApiV1'
import { propertyIcon } from '@/components/svg/properties/propertiesSvgs'
import { useAppStore } from '@/stores/AppStore'
import { useModalStore } from '@/stores/ModalStore'

const AddToCartButton = defineAsyncComponent(() => import('@/components/buttons/ButtonAddToCartButton.vue'))
const PushToMixButton = defineAsyncComponent(() => import('@/components/buttons/ButtonPushToMixButton.vue'))
const ButtonState = defineAsyncComponent(() => import('@/components/buttons/ButtonState.vue'))
const ButtonPlayVideo = defineAsyncComponent(() => import('@/components/buttons/ButtonPlayVideo.vue'))
const Favorite = defineAsyncComponent(() => import('@/components/buttons/ButtonFavorite.vue'))
const DiscountBubble = defineAsyncComponent(() => import('@/components/general/BaseDiscountBubble.vue'))
const RemoteResponsiveImage = defineAsyncComponent(() => import('@/components/general/BaseRemoteResponsiveImage.vue'))
const StampIconSvg = defineAsyncComponent(() => import('@/components/svg/stamp/StampIconSvg.vue'))
const StampItalyFlagSvg = defineAsyncComponent(() => import('@/components/svg/stamp/StampItalyFlagSvg.vue'))
const MixitPlusLogoSvg = defineAsyncComponent(() => import('@/components/svg/MixitPlusLogoSvg.vue'))
const ProductStarsRating = defineAsyncComponent(() => import('@/components/products/ProductStarsRating.vue'))
const ProductItemToast = defineAsyncComponent(() => import('@/components/products/ProductItemToast.vue'))
const ProductPrice = defineAsyncComponent(() => import('@/components/products/ProductPrice.vue'))
const ProductEstimatedTransport = defineAsyncComponent(() => import('@/components/products/ProductEstimatedTransport.vue'))
const appStore = useAppStore()
const { getCurrentCustomer } = storeToRefs(appStore)

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },

  infoClickBehaviour: {
    type: String,
    default: 'modal',
  },

  status: {
    type: String,
    default: 'default'
  },

  lazyLoad: {
    type: Boolean,
    required: false,
  },

  isSearchPage: {
    type: Boolean,
    default: false,
  }
})

const toastObject = ref();

const router = useRouter()
const { openModal } = useModalStore()
const { t } = useI18n()

const shortDescription = ref('')
const productPath = ref({
  name: 'productPath',
  params: { permalink: props.product.permalink },
})

const marketingProperties = computed(() => {
  if (!props.product) return []
  return props.product.properties.filter((p) => p.propertyType === 'marketing')
})

const showProductDetailModal = async (permalink) => {
  const {
    data: { product },
  } = await ApiServiceV1.get(`products/${permalink}`)

  openModal({
    id: 'product-detail-modal',
    title: product.name,
    params: {
      product,
    },
  })
}

const createShortDescription = () => {
  shortDescription.value = props.product.description ? striptags(props.product.description).slice(0, 140) : ''
}

const infoBtnClicked = async () => {
  await (props.infoClickBehaviour === 'modal'
    ? showProductDetailModal(props.product.permalink)
    : router.push({ name: 'productPath', params: { permalink: props.product.permalink } }))
}

onMounted(() => {
  createShortDescription()
})
</script>

<style lang="scss">
.icon-property{ font-size: 30px; }
.icon-question {
  font-size: 12px;
  margin: 1px
}
.rating-divider {
  width: 1px;
  height: 20px;
}
.rating-divider {
  width: 1px;
  height: 20px;
}
</style>

<i18n>
  {
    "cs": {
    "composition": "Složení",
    "from": "Od",
    "mixit_plus_price": "cena",
    "own_piece_of_italy": "Zažijte vlastní kousek Itálie",
    "play_video": "Shlédnout video",
    "selected_chocolate_products": "Jsem u ledu! Z důvodu vysokých teplot mě poslali do chládku.",
    "voucher_permalink": "mixit-plus-na-12-mesicu"
},
    "sk": {
    "composition": "Zloženie",
    "from": "Od",
    "mixit_plus_price": "cena",
    "own_piece_of_italy": "Zažite vlastný kúsok Talianska",
    "play_video": "Pozrieť video",
    "selected_chocolate_products": "Som v chládku! :( Čokoláda má kvôli vysokým teplotám dovolenku.",
    "voucher_permalink": "mixit-plus-na-12-mesiacov"
},
    "pl": {
    "composition": "Skład",
    "from": "Od",
    "mixit_plus_price": "cena",
    "own_piece_of_italy": "Spróbuj prawdziwie włoskiego smaku",
    "play_video": "Zobacz wideo",
    "selected_chocolate_products": "Czekam w chłodzie! :( Ze względu na upały, czekolada została wysłana na przymusowy urlop.",
    "voucher_permalink": "mixit-plus-na-12-miesiecy"
},
    "hu": {
    "composition": "Összetevők",
    "from": "Ft-tól",
    "mixit_plus_price": "ár",
    "own_piece_of_italy": "Egy falat Olaszország",
    "play_video": "Nézd meg a videót",
    "selected_chocolate_products": "Hidegre helyezve! :( A magas hőmérsékletek miatt a csokoládés termékek szabadságon vannak.",
    "voucher_permalink": "mixit-plusz-12-honapra"
},
    "de": {
    "composition": "Zutaten",
    "from": "Von",
    "mixit_plus_price": "preis",
    "own_piece_of_italy": "Erlebe dein eigenes Stück Italien",
    "play_video": "Video ansehen",
    "selected_chocolate_products": "Ich liege auf Eis! :( Wegen der hohen Temperaturen haben sie mich in die Kühlung geschickt.",
    "voucher_permalink": "mixit-plus-fuer-12-monate"
},
    "at": {
    "composition": "Zutaten",
    "from": "Von",
    "mixit_plus_price": "preis",
    "own_piece_of_italy": "Erlebe dein eigenes Stück Italien",
    "play_video": "Video ansehen",
    "selected_chocolate_products": "Ich liege auf Eis! :( Wegen der hohen Temperaturen haben sie mich in die Kühlung geschickt.",
    "voucher_permalink": "mixit-plus-fuer-12-monate"
},
    "ro": {
    "composition": "Ingrediente",
    "from": "De la",
    "mixit_plus_price": "preț",
    "own_piece_of_italy": "Descoperă o bucațică de Italia",
    "play_video": "Urmărește clipul",
    "selected_chocolate_products": "La rece! :( Din cauza temperaturilor înalte produsele cu ciocolată sunt în concediu.",
    "voucher_permalink": "mixit-plus-de-12-luni"
},
    "fr": {
    "composition": "Composition",
    "from": "À partir de",
    "mixit_plus_price": "prix",
    "own_piece_of_italy": "Offrez-vous un bout d’Italie",
    "play_video": "Regardez la vidéo",
    "selected_chocolate_products": "Je suis au frais ! À cause des températures élevées, ils m'ont plongée dans le froid.",
    "voucher_permalink": "mixit-plus-pour-12 mois"
},
    "it": {
    "composition": "Ingredienti",
    "from": "Da",
    "mixit_plus_price": "prezzo",
    "own_piece_of_italy": "Goditi il tuo pezzo d'Italia",
    "play_video": "Guarda il video",
    "selected_chocolate_products": "Sono sotto ghiaccio! A causa delle alte temperature mi hanno mandato in spedizione polare per raffreddarmi.",
    "voucher_permalink": "mixit-plus-per-12-mesi"
}
  }
</i18n>
